import React, { Component } from 'react';

import PopularArticles from './popular-articles/popular-articles';
import ArticleArchivesContainer from './article-archives/article-archives-container';
import TagsContainer from './tags/tags-container';
import AlsoVisit from './also-visit';
import SubscribeButton from './subscribe-btn';
import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';

import BlogAdContainer from '../ads/ad-container';
import DynamicSearchBox from '../search-box/dynamic-search-box';
import withWindowResize from '../../../ui/components/window-resize';

import './right-rail.less';

const TagsSection = withWindowResize(
    ({
        page,
        tagsHeader,
        bannerMeta,
        tags,
        customBreakpoints,
        hideBlogAd,
        hideSearchBox,
        processSearchBoxResponse,
        originCountryCode
    }) => {
        let device = customBreakpoints && customBreakpoints['blog'];
        let isBlogDesktopView = device === 'desktop';
        const className = isBlogDesktopView ? 'blog-tags-desktop' : 'blog-tags-mobile';
        const showBlogAd = !hideBlogAd && (isBlogDesktopView || page !== 'tech-takes-article-view');
        const blogAdClass = `blog-ad-${device} blog-ad-${page}`;
        return (
            <React.Fragment>
                {isBlogDesktopView && <PopularArticles tagsHeader={tagsHeader} tags={tags} />}
                <div className={className}>
                    {/** Only show the ad in the tags section if:
                     *    1. Desktop view of an Article.
                     *    2. Any device (desktop/tablet/mobile) of an article listing page.
                     *  Once the desktop ad is loaded for Article View pages, it should remain (but hidden) on the page
                     *  and shouldn't force the BlogAdBanner to unmount/remount.
                     */}
                    {showBlogAd && (
                        <div className={blogAdClass}>
                            <BlogAdContainer
                                bannerType="rightRailBanner"
                                uniqueIdentifier="blog-right-rail-banner"
                                bannerMeta={bannerMeta}
                                type={device}
                                originCountryCode={originCountryCode}
                            />
                        </div>
                    )}
                    <h3>{tagsHeader}</h3>
                    {isBlogDesktopView && <hr />}
                    <TagsContainer header={tagsHeader} tags={tags} />
                </div>
                {!isBlogDesktopView && <PopularArticles tagsHeader={tagsHeader} tags={tags} />}
                {!hideSearchBox && <DynamicSearchBox page={page} processSearchBoxResponse={processSearchBoxResponse} />}
                <AlsoVisit />
                <ArticleArchivesContainer />
                {showBlogAd && isBlogDesktopView && (
                    <div className={blogAdClass}>
                        <BlogAdContainer
                            bannerType="bannerSkyscraper"
                            uniqueIdentifier="blog-right-rail-banner-skyscraper"
                            bannerMeta={bannerMeta}
                            type={device}
                            originCountryCode={originCountryCode}
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }
);

class RightRail extends Component {
    processSearchBoxResponse = (response = {}) => {
        return Object.keys(response).length
            ? response.results.map(result => {
                  const { blog_title, vanity_url, blog_thumbnail, blog_date, blog_content, id, description } = result;
                  return {
                      blogTitle: blog_title.raw,
                      vanityUrl: vanity_url.raw,
                      blogThumbnail: JSON.parse(blog_thumbnail.raw),
                      blogDate: blog_date.raw,
                      blogContent: blog_content.raw,
                      description: description.raw,
                      document_id: id.raw,
                  };
              })
            : [];
    };

    render() {
        const {
            bannerType,
            subscribeHref,
            subscribeLinkId,
            subscribeLinkType = 'modal',
            tags = [],
            tagsHeader,
            page,
            subscribeClick,
            bannerMeta,
            hideBlogAd,
            hideSearchBox,
            originCountryCode
        } = this.props;
        const tagProps = {
            tagsHeader,
            tags,
            page,
            bannerMeta,
            hideBlogAd,
            bannerType,
            hideSearchBox,
            processSearchBoxResponse: this.processSearchBoxResponse,
            originCountryCode
        };
        return (
            <AboveTheFoldOnlyServerRender
                skipEval={deviceType => {
                    //skip if mobile or tablet
                    return deviceType === 'mobile' || deviceType === 'tablet';
                }}
                /* we can try lazy load later, but for now dont SSR for mobile and tablet since it's below the fold
                offset={300}
                placeholderStyle={{height: 950}}
                placeholderClassName={'lazyload right-rail-container'}*/
            >
                <div className="right-rail-container">
                    <SubscribeButton
                        handleClick={subscribeClick}
                        linkId={subscribeLinkId}
                        href={subscribeHref}
                        metricsElementType={subscribeLinkType}
                    />
                    <TagsSection {...tagProps} />
                </div>
            </AboveTheFoldOnlyServerRender>
        );
    }
}

export default RightRail;
